export default __webpack_public_path__ + "static/media/linked-account.6243817a.jpg";